import React from "react";
import styles from "../Pricing.module.scss";
import visa from "../../../../../../../images/v2/visa24x24.svg";
import master from "../../../../../../../images/v2/master24x24.svg";
import discover from "../../../../../../../images/v2/discover24x24.svg";
import amex from "../../../../../../../images/v2/amex24x24.svg";

const AMEX_TIERS = [
  {
    id: 'one',
    title: 'Amex Tier 1',
    rates: [
      { label: 'Rate', id: 32 },
      { label: 'Txn rate', id: 32 }
    ]
  },
  {
    id: 'two',
    title: 'Amex Tier 2',
    rates: [
      { label: 'Rate', id: 33 },
      { label: 'Txn rate', id: 33 }
    ]
  },
  {
    id: 'three',
    title: 'Amex Tier 3',
    rates: [
      { label: 'Rate', id: 34 },
      { label: 'Txn rate', id: 34 }
    ]
  },
  {
    id: 'four',
    title: 'Amex Tier 4',
    rates: [
      { label: 'Rate', id: 49 },
      { label: 'Txn rate', id: 49 }
    ]
  }
];

const AMEX_FLAT_RATE = [
  {
    id: 'one',
    title: 'Amex Flat rate',
    rates: [
      { label: 'Flat Rate', id: 35 },
      { label: 'Txn rate', id: 35 }
    ],
    ic_rates: [
      { label: 'Interchange Rate', id: 35 },
      { label: 'Txn rate', id: 35 }
    ]
  },
];

function Tiered({ activeApp, minimized }) {
  const getPricingDataById = (id) => {
    let pricing = activeApp?.prices?.find((price) => price.id === id);
    return pricing ? pricing.pivot : { dollars: 0, percent: 0 };
  };

  const hasValidPricing = (pricingId, debitId) => {
    const pricing = getPricingDataById(pricingId);
    const debitPricing = debitId ? getPricingDataById(debitId) : null;

    return (
      (pricing.dollars > 0 || pricing.percent > 0) ||
      (debitPricing && (debitPricing.dollars > 0 || debitPricing.percent > 0))
    );
  };

  const renderDataItem = (label, value) => (
    <div className={styles.fee_item}>
      <div className={styles.fee_content}>
        <div className={styles.fee_label}>{label}</div>
        <div className={styles.fee_value}>{value}</div>
      </div>
    </div>
  );

  const renderQualifiedSection = () => (
    <div className={styles.tiered_section}>
      <div className={styles.tiered_header}>
        <h4 className={styles.tiered_title}>Qualified</h4>
        <div className={styles.card_images}>
          <img src={visa} alt="visa" />
          <img src={master} alt="mastercard" />
          <img src={discover} alt="discover" />
        </div>
      </div>
      <div className={`${styles.fees_grid} ${styles.tiered_fees_grid}`}>
        {renderDataItem("Qual rate", `${getPricingDataById(1).percent}%`)}
        {renderDataItem("Txn rate", `$ ${getPricingDataById(1).dollars}`)}
        {renderDataItem("Debit Rate", `${getPricingDataById(39).percent}%`)}
        {renderDataItem("Debit Per Txn", `$ ${getPricingDataById(39).dollars}`)}
      </div>
    </div>
  );

  const renderMidQualifiedSection = () => (
    <div className={styles.tiered_section}>
      <div className={styles.tiered_header}>
        <h4 className={styles.tiered_title}>Mid-Qualified</h4>
        <div className={styles.card_images}>
          <img src={visa} alt="visa" />
          <img src={master} alt="mastercard" />
          <img src={discover} alt="discover" />
        </div>
      </div>
      <div className={`${styles.fees_grid} ${styles.tiered_fees_grid}`}>
        {renderDataItem("Qual rate", `${getPricingDataById(3).percent}%`)}
        {renderDataItem("Txn rate", `$ ${getPricingDataById(3).dollars}`)}
        {renderDataItem("Debit Rate", `${getPricingDataById(40).percent}%`)}
        {renderDataItem("Debit Per Txn", `$ ${getPricingDataById(40).dollars}`)}
      </div>
    </div>
  );

  const renderNonQualifiedSection = () => (
    <div className={styles.tiered_section}>
      <div className={styles.tiered_header}>
        <h4 className={styles.tiered_title}>Non-Qualified</h4>
        <div className={styles.card_images}>
          <img src={visa} alt="visa" />
          <img src={master} alt="mastercard" />
          <img src={discover} alt="discover" />
        </div>
      </div>
      <div className={`${styles.fees_grid} ${styles.tiered_fees_grid}`}>
        {renderDataItem("Qual rate", `${getPricingDataById(4).percent}%`)}
        {renderDataItem("Txn rate", `$ ${getPricingDataById(4).dollars}`)}
        {renderDataItem("Debit Rate", `${getPricingDataById(41).percent}%`)}
        {renderDataItem("Debit Per Txn", `$ ${getPricingDataById(41).dollars}`)}
      </div>
    </div>
  );

  const renderAmexSection = () => (
    <div className={styles.amex_structure}>
      <div className={styles.amex_header}>
        <div className={styles.amex_title}>AMEX STRUCTURE</div>
        <div className={styles.card_images}>
          <img src={amex} alt="amex" />
        </div>
      </div>
      <div className={styles.amex_details}>
        {renderDataItem("Preferred AMEX Structure", "Tiered Rate")}
      </div>
      <div className={styles.amex_tiers}>
        {AMEX_TIERS.map((tier) => (
          <div key={tier.id} className={styles.tiered_section}>
            <div className={styles.tiered_header}>
              <h4 className={styles.tiered_title}>{tier.title}</h4>
            </div>
            <div className={`${styles.fees_grid} ${styles.tiered_fees_grid}`}>
              {tier.rates.map((rate) => (
                renderDataItem(
                  rate.label,
                  rate.label.includes('Rate')
                    ? `${getPricingDataById(rate.id).percent}%`
                    : `$ ${getPricingDataById(rate.id).dollars}`
                )
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderAmexFlatSection = () => (
    <div className={styles.amex_structure}>
      <div className={styles.amex_header}>
        <div className={styles.amex_title}>AMEX STRUCTURE</div>
        <div className={styles.card_images}>
          <img src={amex} alt="amex" />
        </div>
      </div>
      <div className={styles.amex_details}>
        {renderDataItem("Preferred AMEX Structure", activeApp?.pricing_model == "flat_rate" ? "Flat Rate" : 'Interchange Plus')}
      </div>
      <div className={styles.amex_tiers}>
        {AMEX_FLAT_RATE.map((tier) => (
          <div key={tier.id} className={styles.tiered_section}>
            <div className={styles.tiered_header}>
              <h4 className={styles.tiered_title}>{activeApp?.pricing_model == "flat_rate" ? "AMEX Flat rate" : "AMEX Interchange Plus"}</h4>
            </div>
            <div className={`${styles.fees_grid} ${styles.tiered_fees_grid}`}>
              {activeApp?.pricing_model == "flat_rate" ? (
                <>
                  {tier.rates.map((rate) => (
                    renderDataItem(
                      rate.label,
                      rate.label.includes('Rate')
                        ? `${getPricingDataById(rate.id).percent}%`
                        : `$ ${getPricingDataById(rate.id).dollars}`
                    )
                  ))}
                </>
              ) : (
                <>
                  {tier.ic_rates.map((rate) => (
                    renderDataItem(
                      rate.label,
                      rate.label.includes('Rate')
                        ? `${getPricingDataById(rate.id).percent}%`
                        : `$ ${getPricingDataById(rate.id).dollars}`
                    )
                  ))}
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );


  return (
    <div className={styles.tiered}>
      <div className={minimized ? styles.tiered_row_minimized : styles.tiered_row}>
        {hasValidPricing(1, 39) && renderQualifiedSection()}
        {hasValidPricing(3, 40) && renderMidQualifiedSection()}
        {hasValidPricing(4, 41) && renderNonQualifiedSection()}
      </div>
      {hasValidPricing(32) && renderAmexSection()}
      {hasValidPricing(35) && renderAmexFlatSection()}
    </div>
  );
}

export default Tiered; 